import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "¿Qué es BrandWay©?",
    answer: "Es un proceso integral de rebranding estratégico diseñado para marcas con trayectoria que necesitan renovar su identidad, blindar su valor y posicionarse con autoridad en su industria. En 120 días transformamos la percepción de tu marca."
  },
  {
    question: "¿Para quién está diseñado BrandWay©?",
    answer: "Para empresas y profesionales con trayectoria que crecieron más rápido que su marca. Negocios que ya tienen recorrido pero cuya identidad visual y estratégica no refleja el valor real que entregan."
  },
  {
    question: "¿Qué incluye el proceso?",
    answer: "Incluye rebranding completo (identidad visual, sistema gráfico, estrategia de marca), estrategia de comunicación, sesiones de consultoría estratégica y acompañamiento durante 120 días."
  },
  {
    question: "¿Cuánto dura el proceso?",
    answer: "El proceso completo de BrandWay© tiene una duración de 120 días, con entregas progresivas y acompañamiento constante para asegurar la implementación efectiva de cada etapa."
  },
  {
    question: "¿Qué resultados puedo esperar?",
    answer: "Una marca renovada que comunica autoridad y confianza, incremento en la percepción de valor por parte de tus clientes, mayor diferenciación en tu industria y una identidad preparada para escalar."
  },
  {
    question: "¿Trabajan con empresas de cualquier industria?",
    answer: "Sí. Hemos trabajado con más de 20 industrias diferentes en 15 países: salud, gastronomía, real estate, tecnología, servicios profesionales, retail y muchas más. Nuestra metodología se adapta a cada sector."
  },
  {
    question: "¿Cómo sé si mi marca necesita un rebranding?",
    answer: "Si sentís que tu negocio creció pero tu marca se quedó atrás, si tus clientes no perciben el valor real que entregás, o si tu identidad visual no refleja la calidad de tu trabajo, es momento de dar el paso."
  },
  {
    question: "¿Cómo empiezo?",
    answer: "Hacé clic en APLICAR, completá tus datos y nos pondremos en contacto para evaluar tu caso. Seleccionamos cuidadosamente cada proyecto para garantizar resultados excepcionales."
  }
];

const FAQ = () => {
  return (
    <section className="py-24 md:py-32 relative overflow-hidden bg-muted/30" id="faq">
      <div className="container px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <span className="text-primary text-sm font-semibold tracking-widest uppercase mb-4 block">
            Resolvemos tus dudas
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Preguntas <span className="text-gradient-gold italic">Frecuentes</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-background rounded-xl border border-border px-6 data-[state=open]:border-primary/30 transition-colors"
              >
                <AccordionTrigger className="text-left font-display text-lg font-medium hover:no-underline py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed whitespace-pre-line pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
